<template>
  <div class="cardSize">
    <md-card class="md-card-profile">


      <md-card-content >
        <div >
          <div class="md-card-avatar" style="display: inline-block;margin-right: 5%">
            <img style="" class="img" :src= profilePicture>
          </div>
          <div style="display: inline-block; text-align: center;margin-top: 5%">
            <h3 class="category text-gray">{{ name }}</h3>
            <h4 class="card-title">{{ gender }}</h4>
            <p class="card-description">
              Date of Birth : {{ DOB }}</p>
          </div>
          <hr style="border-color: rgba(230, 230, 230, 0.15)">
          <div v-if="isDonor" style="margin-top: 7%">
            <p class="category text-gray">Blood Group: {{ bloodgroup.blood_group }}</p>
            <p class="category text-gray">Height: {{ height }} feet</p>
            <p class="category text-gray">Weight: {{ weight }} KG</p>
            <p class="card-description">
              Last Donate : {{ lastDonate }}
            </p>
          </div>
          <md-button class="md-round md-success" style="margin-top: 7%;margin-bottom: 10%;border-radius: 5%">Edit Profile</md-button>
        </div>

      </md-card-content>
    </md-card>

  </div>
</template>

<script>
  import ApiRoutes from '@/API/ApiRoutes'
  var moment = require('moment');

  export default {
  name: 'user-card',
  data () {
    return {
      name:'',
      gender:'',
      profilePicture: '',
      DOB: '',
      bloodgroup:'',
      height:'',
      weight:'',
      lastDonate:'',
      isDonor:false
    }
  },
  mounted(){
    let localdata = JSON.parse(localStorage.getItem('user-response'));
    if(localdata.data.user_profile){
      this.name = localdata.data.user_profile.name;
      this.gender = localdata.data.user_profile.gender.gender;
      //this.profilePicture = localdata.data.user_profile.picture_path;
      this.DOB = localdata.data.user_profile.date_of_birth;
      this.DOB = moment(this.DOB).format('LL');
      var url =  localdata.data.user_profile.picture_path;
      console.log("picture",url)
      this.profilePicture = ApiRoutes.BASEURL+ ApiRoutes.PORT +url;
      /*this.profilePicture = ApiRoutes.BASEURL +url;*/
      console.log("picture",this.profilePicture)

      if (localdata.data.donor_profile) {
        this.isDonor = true;
        this.bloodgroup = localdata.data.donor_profile.blood_group;
        this.height = localdata.data.donor_profile.height;
        this.weight = localdata.data.donor_profile.weight;
        this.lastDonate = localdata.data.donor_profile.last_donate;
        console.log(this.lastDonate)
      }
    }
  }
}

</script>
<style>
  .cardSize .md-card{
    width: auto !important;
    left: 30%;
  }
  @media only screen and (max-width: 600px){
    .cardSize .md-card{
      width: 100% !important;
      left: 0%;
    }
  }
</style>
